import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Divider from 'LuxKit/Divider'
import LuxPlusPreferredPaymentMethod from 'luxPlus/components/LuxPlusPreferredPaymentMethod'
import LuxPlusBackupPaymentMethods from 'luxPlus/components/LuxPlusManageAccount/LuxPlusBackupPaymentMethods'
import type { ReactNode } from 'react'

interface Props {
  expectedBackupPaymentMethodId?: string
  item: App.MemberSubscriptionItem
  onAddBackupPaymentMethod?: () => void
  onExpectedBackupPaymentMethodFound?: () => void
  onUpdatePaymentMethod?: () => void
  refreshKey?: number
  renewalDate?: string
  preferredPaymentMethodFooter?: ReactNode
}

function LuxPlusPaymentMethods(props: Props) {
  const {
    expectedBackupPaymentMethodId,
    item,
    onAddBackupPaymentMethod,
    onExpectedBackupPaymentMethodFound,
    onUpdatePaymentMethod,
    refreshKey,
    renewalDate,
    preferredPaymentMethodFooter,
  } = props

  return <VerticalSpacer gap={12}>
    <LuxPlusPreferredPaymentMethod
      item={item}
      onUpdatePaymentMethod={onUpdatePaymentMethod}
      refreshKey={refreshKey}
      renewalDate={renewalDate}
      showDivider={false}
      footer={preferredPaymentMethodFooter}
    />
    <Divider kind="primary" />
    <LuxPlusBackupPaymentMethods
      expectedBackupPaymentMethodId={expectedBackupPaymentMethodId}
      item={item}
      onAddBackupPaymentMethod={onAddBackupPaymentMethod}
      onExpectedBackupPaymentMethodFound={onExpectedBackupPaymentMethodFound}
      refreshKey={refreshKey}
      renewalDate={renewalDate}
      showDivider={false}
    />
  </VerticalSpacer>
}

export default LuxPlusPaymentMethods
